import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import logoDark from './dark.svg';
import logoWhite from './light.svg';
import Page from '../../page';
/**
 * @param {import('./types').PageNotFoundProps} props
 */

var NotFound = function NotFound(_ref) {
  var image = _ref.image,
      pageErrorProps = _objectWithoutProperties(_ref, ["image"]);

  var dark = pageErrorProps.dark,
      rest = _objectWithoutProperties(pageErrorProps, ["dark"]);

  var svgImageSrc = dark ? logoDark : logoWhite;
  if (image) svgImageSrc = image;
  return React.createElement(Page.Error, Object.assign({
    dark: dark,
    image: svgImageSrc
  }, rest));
};

NotFound.defaultProps = {
  title: "404 - Page not found",
  message: "We're sorry, we couldn't find the page you requested.",
  dark: false,
  buttonText: "Go to home page"
};
export default NotFound;